<template>
    <div class="widget-sorting-params">
        <div class="mb-4">
            <RedesignRadioGroup
                v-model="sortingOrderModel"
                class=""
            >
                <RedesignRadioButton
                    :label="ASC_SORTING"
                >
                    {{ $t('sorting.asc') }}
                </RedesignRadioButton>
                <RedesignRadioButton
                    :label="DESC_SORTING"
                >
                    {{ $t('sorting.desc') }}
                </RedesignRadioButton>
            </RedesignRadioGroup>
        </div>
        <div>
            <RedesignBaseSelect
                v-model="sortingPropModel"
                :data="propsList"
                :multiple="false"
                class="w-full max-w-full"
                full-width
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import RedesignRadioGroup from '@/components/RedesignBaseComponents/Inputs/RedesignRadioGroup.vue'
import { SortingParams, WidgetTemplateColumn } from '@/types/dashboard'
import RedesignRadioButton from '@/components/RedesignBaseComponents/Inputs/RedesignRadioButton.vue'
import RedesignBaseSelect from '@/components/RedesignBaseComponents/Inputs/RedesignBaseSelect.vue'
import { getTranslationOrUndefined } from '@/helpers/translation'
import startCase from 'lodash/startCase'

const DEFAULT_ORDER = 'ascending'
const ASC_SORTING = 'ascending'
const DESC_SORTING = 'descending'

type TPropsList = {label: string, value: string }

const props = defineProps<{
    value: SortingParams,
    templateColumns?: Array<WidgetTemplateColumn>
}>()

const emit = defineEmits([ 'update:value', 'input' ])

const propsList = ref<Array<TPropsList>>([])

const sortingOrderModel = computed({
    get () {
        return props.value?.order
    },
    set (val) {
        emit('input', {
            ...props.value,
            order: val
        })
    }
})
const sortingPropModel = computed({
    get () {
        return props.value?.prop
    },
    set (val) {
        emit('input', {
            ...props.value,
            prop: val
        })
    }
})


function initSortingParams () {
    sortingPropModel.value = props.value?.prop ?? ''
    
    if (props.value?.order) {
        sortingOrderModel.value = props.value.order
    }

    if (!props.templateColumns) {
        propsList.value = []
        return
    }
    const _list: Array<TPropsList> = []
    props.templateColumns.forEach(column => {
        const label = getTranslationOrUndefined(column.TemplateNameContentTag)
            || getTranslationOrUndefined(column.WidgetTemplateColumnsName)
            || startCase(column.WidgetTemplateColumnsName)

        _list.push({
            label: `${label}`,
            value: column.WidgetTemplateColumnsTag
        })
    })
    propsList.value = [ ..._list ]
}

onMounted(initSortingParams)
</script>
